import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, ChannelDeviceStatusDTO } from '../../../../../services/api/api';
import { ErrorService } from '../../../../../services/error.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../../../../../services/util.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-comp-player-reporting-header',
  templateUrl: './player-header.component.html',
  styleUrls: ['./player-header.component.scss'],
  standalone: false,
})
export class PlayerHeaderComponent implements OnInit {
  networkData: ChannelDeviceStatusDTO;

  constructor(
    private api: API,
    public errorHandler: ErrorService,
    public translate: TranslateService,
    public util: UtilService,
    private destroyRef: DestroyRef
  ) {
    this.networkData = null;
  }

  ngOnInit(): void {
    this.api
      .ss_nm_Network_deviceStatus({
        productive: true,
      })
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: data => {
          this.networkData = data;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }
}
